import type { StageEnum } from '@hvf/contracts'
import type { Component } from 'solid-js'
import Chip from './Chip'

type StageBadgeProps = {
  patternStage?: StageEnum | null
  wrap?: boolean
}

export const stageColor = (stage?: StageEnum | null): string => {
  switch (stage) {
    case 'funneling':
      return '#f3a23a'
    case 'triggered':
      return 'var(--colors-editorial-accent)'
    case 'first_interim':
    case 'second_interim':
    case 'second_chance':
      return '#5aa9ff'
    case 'target':
      return 'var(--colors-editorial-accent-deep)'
    case 'overperformance':
    case 'overperformance-closed':
      return 'var(--colors-editorial-primer)'
    case 'stopped-out':
    case 'spoiled':
      return 'var(--colors-editorial-chat)'
    case 'timed-out':
      return '#e0922a'
    default:
      return 'var(--colors-editorial-ink3)'
  }
}

const StageBadge: Component<StageBadgeProps> = (props) => {
  const label = () => (props.patternStage || 'unspecified').replaceAll('_', ' ').replaceAll('-', ' ')

  return (
    <Chip
      color={stageColor(props.patternStage)}
      tooltip='Pattern Status'
      wrap={props.wrap}
    >
      {label()}
    </Chip>
  )
}

export default StageBadge
